import request from '@/utils/request2'

// 保存
export function saveAttachmentInfoApi(data) {
  return request({
    url: 'tms-web/attachmentInfo/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteAttachmentInfoApi(data) {
  return request({
    url: 'tms-web/attachmentInfo/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewAttachmentInfoApi(data) {
  return request({
    url: 'tms-web/attachmentInfo/view',
    method: 'post',
    data
  })
}

// 列表
export function listAttachmentInfoApi(data) {
  return request({
    url: 'tms-web/attachmentInfo/list',
    method: 'post',
    data
  })
}

// 根据路径删除文件
export function deleteFileApi(data) {
  return request({
    url: 'tms-file/file/delete',
    method: 'post',
    data
  })
}
